export const formatISODateBKK = (dateStr = "") => {
  const localeDate = new Date(dateStr).toLocaleDateString("en-th", {
    timeZone: "Asia/Bangkok",
  });
  const dateArray = localeDate.split("/");
  const day = String(dateArray[1]).padStart(2, "0");
  const month = String(dateArray[0]).padStart(2, "0");
  const year = String(dateArray[2]);
  return dateStr.length ? `${day}/${month}/${year}` : "";
};
